import { Component, Input, ElementRef, EventEmitter, Output, OnInit, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { TipoClassificacao } from '../tipo-classificacao';
import { TipoClassificacaoFilter } from '../filter/tipo-classificacao-filter';
import { TipoClassificacaoCrudHttpService } from '../services';
import { tipoClassificacaoSituacaoAtivo, isSituacaoInativo } from '../tipo-classificacao-situacao';
import { tipoClassificacaoCadastroCliente, tipoClassificacaoCadastroItem } from '../cadastro';
import { TipoClassificacaoGrupoCadastro } from '../tipo-classificacao-grupo-cadastro';
import { TipoClassificacaoGrupoCadastroFilterPipe, TipoClassificacaoGrupoCadastroPipe } from '../pipes';

@Component({
    selector: 'sgt-tipo-classificacao-select',
    templateUrl: './tipo-classificacao-select.component.html',
    styleUrls: ['./tipo-classificacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TipoClassificacaoSelectComponent), multi: true },
    ]
})
export class TipoClassificacaoSelectComponent implements OnInit {
    grupos: TipoClassificacaoGrupoCadastro[];

    /** ID do tipo da classificação */
    @Input() ngModel: number;
    /** Ao alterar o tipo da classificação selecionada */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Objeto do tipo da classificação */
    @Input() tipoClassificacao: TipoClassificacao;
    @Output() tipoClassificacaoChange = new EventEmitter<TipoClassificacao>();

    /**
     * Nome do input
     */
    @Input() name: string;
    /**
     * ID do input
     */
    @Input() id: string;
    /**
     * Se o valor é obrigatório
     */
    @Input() required: any;
    /**
     * Se deve desabilitar o input
     */
    @Input() disabled: boolean;

    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    /** Se deve exibir os tipos agrupados pelo cadastro */
    @Input() groupByCadastro = true;
    /** Se deve selecionar o primeiro tipo de classificação após a pesquisa */
    @Input() selectFirstAfterSearch = false;
    /** Se deve filtrar somente os tipos das classificações ativos */
    @Input() somenteAtivos = false;
    /** Se deve filtrar os tipos de cadastro de cliente */
    @Input() cadastroCliente = true;
    /** Se deve filtrar os tipos de cadastro de item */
    @Input() cadastroItem = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private tipoClassificacaoCrudHttpService: TipoClassificacaoCrudHttpService,
                private tipoClassificacaoGrupoCadastroFilterPipe: TipoClassificacaoGrupoCadastroFilterPipe,
                private tipoClassificacaoGrupoCadastroPipe: TipoClassificacaoGrupoCadastroPipe) { }

    ngOnInit() {
        this.search();
    }

    /** Verifica se o tipo da classificação do item esta inativo */
    isSituacaoInativo(situacao: number): boolean {
        return isSituacaoInativo(situacao);
    }

    /** Pesquisa os grupos das classificações pelo tipo */
    private search() {
        this.grupos = [];

        const filter = new TipoClassificacaoFilter();
        // Somente ativas
        if (this.somenteAtivos) {
            filter.situacao = tipoClassificacaoSituacaoAtivo.id;
        }

        // Cadastro Cliente
        if (this.cadastroCliente) {
            filter.cadastros.push(tipoClassificacaoCadastroCliente.id);
        }

        // Cadastro Item
        if (this.cadastroItem) {
            filter.cadastros.push(tipoClassificacaoCadastroItem.id);
        }

        this.tipoClassificacaoCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                tiposClassificacoes => {
                    this.grupos = this.tipoClassificacaoGrupoCadastroFilterPipe.transform(tiposClassificacoes);

                    // Selecionar o primeiro tipo de classificação quando ainda não possuir valor
                    if (this.selectFirstAfterSearch && tiposClassificacoes?.length > 0 && !this.ngModel) {
                        this.onChange(tiposClassificacoes[0].id);
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os tipos de segmentos', error)
            );
    }

    /** Ao alterar o tipo da classificação */
    onChange(idTipoClassificacao: number) {
        this.ngModel = idTipoClassificacao;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.tipoClassificacao = this.tipoClassificacaoGrupoCadastroPipe.transform(this.grupos, idTipoClassificacao);
        this.tipoClassificacaoChange.emit(this.tipoClassificacao);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
